<template>
  <div>
    <!-- <route-list :routes="this.routes" /> -->
    <router-view></router-view>
  </div>
</template>

<script>
import RouteList from "./Components/RouteList";
export default {
  components: {
    RouteList,
  },
  data() {
    return {
      routes: [
        { name: "Invoices", path: "invoice", icon: "list-ul" },
        {
          name: "Create Invoices",
          path: "invoice/create",
          icon: "plus-circle",
        },
      ],
    };
  },
};
</script>
